import React, { Component } from 'react';

export default class RecordRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      report: {}
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { report: nextReport } = nextProps;
    if (nextReport) {
      let report = nextReport;
      this.setState({
        report
      });
    }
  }

  formatNumber(num) {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return num_parts.join(",");
  }

  render() {
    const { report, stt } = this.props;

    return (
      <>
        {report && report.dimensions && report.metrics &&
          <tr>
            <td style={{ width: "15px" }}>{parseInt(stt) + 1}.</td>
            <td>
              <a href={"https://saostar.vn" + report.dimensions[0]}> {report.dimensions[2]} </a>
            </td>
            <td className="text-right" style={{ width: "100px" }}>{this.formatNumber(report.metrics[0].values[0])}</td>
          </tr>
        }
        {report && report.dimensionValues && report.metricValues &&
          <tr>
            <td style={{ width: "15px" }}>{parseInt(stt) + 1}.</td>
            <td>
              <a href={"https://saostar.vn" + report.dimensionValues[0].value}> {report.dimensionValues[2].value} </a>
            </td>
            <td className="text-right" style={{ width: "100px" }}>{this.formatNumber(report.metricValues[0].value)}</td>
          </tr>
        }
      </>
    );
  }
}